var map = {
	"./de/cv-pause.png": "6em5",
	"./en/cv-pause.png": "yfiY",
	"./es/cv-pause.png": "mueP",
	"./fr/cv-pause.png": "IhT2",
	"./ja/cv-pause.png": "lCxM",
	"./ko/cv-pause.png": "EqQj",
	"./pt/cv-pause.png": "D/fd",
	"./ru/cv-pause.png": "mwgX",
	"./tc/cv-pause.png": "VTk/",
	"./th/cv-pause.png": "Q6Up"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KRJA";